import { getVimeoEmbedUrl, getYouTubeEmbedUrl } from '../../helpers/embed';
import { Image } from '../Media/Media';
import { Embed, EmbedResource } from './Embed';

export const transformToEmbedThumbnail = (resource: EmbedResource): Image => {
    const extension = resource.thumbnail
        ? resource.thumbnail.split('.').at(-1)
        : undefined;

    const mime = extension
        ? `image/${extension}`
        : '';

    return {
        src: resource.thumbnail,
        alt: resource.title,
        formats: {},
        mime,
    };
};

export const transformToEmbed = (resource: EmbedResource): Embed => {
    const html = resource.rawData?.html;
    const thumbnail = transformToEmbedThumbnail(resource);

    return {
        title: resource.title,
        url: resource.url,
        html,
        thumbnail,
    };
};

export const transformToEmbedUrl = (resource: string): string => {
    const youTubeEmbedUrl = getYouTubeEmbedUrl(resource);
    const vimeoEmbedUrl = getVimeoEmbedUrl(resource);

    return youTubeEmbedUrl || vimeoEmbedUrl || resource;
};
